var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _rect, _rect2, _path9, _path0, _path1, _rect3, _rect4, _rect5, _path10, _path11, _ellipse, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _rect6, _path20, _circle, _circle2, _path21;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVerificationEmail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 253,
    height: 236,
    viewBox: "0 0 253 236",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M233.913 104.254C229.518 96.9215 222.014 83.7737 216.131 77.5654C206.025 66.9001 177.948 61.9064 164.061 57.8659C164.061 57.8659 131.437 46.1129 113.541 46.9398C94.9262 47.8001 78.4619 53.2588 62.9217 63.7897C52.5536 70.8157 41.3224 80.0348 33.4184 89.5916C28.9892 94.9471 14.7411 111.729 14.9455 118.661C15.3774 133.305 27.4598 141.405 37.9331 151.549C40.1932 153.738 47.1272 157.27 47.595 160.705C48.0667 164.169 49.6873 168 52.4646 170.221C55.9462 173.005 62.0106 173.725 66.3376 172.603C80.1661 169.017 93.4027 164.556 107.803 165.212C112.614 165.431 116.982 165.84 121.322 168.039C128.004 171.425 133.888 176.217 140.594 179.541C150.334 184.368 165.232 181.978 175.563 179.514C180.776 178.27 185.07 176.16 189.773 173.607C197.467 169.428 205.438 165.524 212.575 160.427C217.764 156.722 228.31 150.823 232.138 146.148C241.636 134.548 240.951 115.998 233.913 104.254Z",
    fill: "#FFD5E5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M67.6306 51.4142L69.6239 57.4347L75.0107 59.6625L69.6239 61.8903L67.6306 67.9108L65.6373 61.8903L60.2506 59.6625L65.6373 57.4347L67.6306 51.4142Z",
    fill: "#4ABBFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M45.4905 134.765V133.029C45.4905 130.871 47.2398 129.122 49.3976 129.122V129.122C51.5554 129.122 53.3047 127.373 53.3047 125.215V125.215C53.3047 123.057 51.5554 121.308 49.3976 121.308H39.4128C36.5357 121.308 34.2034 118.975 34.2034 116.098V116.098C34.2034 113.221 36.5357 110.889 39.4128 110.889H44.8393C47.117 110.889 48.9635 109.042 48.9635 106.765V106.548C48.9635 104.39 47.2142 102.64 45.0564 102.64V102.64C42.8986 102.64 41.1493 100.891 41.1493 98.7334V98.111C41.1493 96.2306 42.5413 94.6407 44.4052 94.3922V94.3922C46.2691 94.1436 47.6611 92.5537 47.6611 90.6733V87.4462",
    stroke: "white",
    strokeWidth: 0.868241,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M110.609 39.2589L113.892 47.8143L122.764 50.9801L113.892 54.1459L110.609 62.7014L107.325 54.1459L98.4532 50.9801L107.325 47.8143L110.609 39.2589Z",
    fill: "#FE8591"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M154.455 62.7014L156.213 67.4544L160.966 69.2132L156.213 70.972L154.455 75.725L152.696 70.972L147.943 69.2132L152.696 67.4544L154.455 62.7014Z",
    fill: "#4ABBFF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7094 167.431C16.1292 168.758 17.8274 170.043 20.2858 171.298C21.5655 171.951 22.971 172.81 25.9706 173.383C34.6003 175.287 59.2694 178.379 59.2694 178.379C59.2694 178.379 84.8249 182.058 102.667 183.023C121.227 184.028 140.112 184.237 160.765 183.655C174.544 183.267 190.316 182.615 203.029 181.711C210.153 181.205 232.835 179.641 236.281 178.625C243.559 176.48 236.064 174.576 231.21 172.473C230.162 172.019 225.274 171.087 226.625 170.562C227.987 170.032 228.739 168.57 227.205 168.08C223.187 166.797 219.208 164.882 212.941 163.781C203.801 162.177 169.781 160.438 159.141 160.174C142.59 159.763 123.533 160.354 112.034 160.08C106.309 159.944 101.023 159.989 95.1062 160.073C85.4249 160.211 75.6194 160.293 65.9968 160.597C59.0009 160.819 45.6414 161.033 39.4606 161.477C24.1224 162.579 15.0372 165.305 15.7094 167.431Z",
    fill: "#FE8591"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M174.858 124.989C174.858 121.818 176.432 118.854 179.059 117.078L211.324 95.2604L221.693 118.723C225.161 126.572 226.953 135.059 226.953 143.64V166.357C226.953 166.874 226.505 167.276 225.991 167.22L183.38 162.604C178.532 162.079 174.858 157.985 174.858 153.109V124.989Z",
    fill: "#FFA90D"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M174.858 96.5628C174.858 91.2881 179.134 87.0121 184.409 87.0121H192.297C193.113 87.0121 193.925 87.1166 194.714 87.3231L205.059 90.0297C209.262 91.1291 212.193 94.9257 212.193 99.2694V116.532C212.193 117.012 211.804 117.401 211.324 117.401H184.409C179.134 117.401 174.858 113.125 174.858 107.85V96.5628Z",
    fill: "#FFA90D"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 167.044,
    y: 139.107,
    width: 31.2567,
    height: 32.1249,
    rx: 15.6283,
    fill: "#FFA90D"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 164.439,
    y: 159.944,
    width: 40.8073,
    height: 11.2871,
    rx: 5.64356,
    fill: "#FFA90D"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M249.527 129.556C251.445 129.556 253 128.001 253 126.083C253 124.165 251.445 122.61 249.527 122.61V129.556ZM213.929 170.363H231.618V163.417H213.929V170.363ZM242.905 159.076V133.897H235.959V159.076H242.905ZM247.246 129.556H249.527V122.61H247.246V129.556ZM242.905 133.897C242.905 131.5 244.849 129.556 247.246 129.556V122.61C241.013 122.61 235.959 127.663 235.959 133.897H242.905ZM231.618 170.363C237.852 170.363 242.905 165.31 242.905 159.076H235.959C235.959 161.474 234.016 163.417 231.618 163.417V170.363Z",
    fill: "#FFA90D"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M177.463 78.3297L193.091 92.2216H177.463L177.463 78.3297Z",
    fill: "#FFA90D"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M191.355 78.3297L208.72 92.2216H191.355L191.355 78.3297Z",
    fill: "#FFA90D"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 179.2,
    y: 114.796,
    width: 23.4425,
    height: 51.2262,
    rx: 9.55065,
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 192.223,
    y: 135.634,
    width: 34.7296,
    height: 35.5979,
    rx: 17.3648,
    fill: "#FFA90D"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 188.75,
    y: 159.944,
    width: 29.5202,
    height: 11.2871,
    rx: 5.64356,
    fill: "#FFA90D"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M215.806 124.997C197.061 119.708 189.754 124.302 189.409 131.052",
    stroke: "#FFA90D",
    strokeWidth: 8.68241,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.3913 138.366C32.9118 138.366 32.5231 138.754 32.5231 139.234V168.635C32.5231 168.741 32.5424 168.844 32.5777 168.938C32.5415 168.978 32.523 169.018 32.523 169.058C32.523 169.177 32.6832 169.292 32.9837 169.401C33.0751 169.45 33.1762 169.483 33.2834 169.496C35.1567 170.018 40.2825 170.393 46.3124 170.393C52.3166 170.393 57.4245 170.021 59.3173 169.503H60.1018V139.234C60.1018 138.754 59.713 138.366 59.2335 138.366H33.3913Z",
    fill: "#944992"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 46.3123,
    cy: 138.811,
    rx: 12.8997,
    ry: 1.33445,
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.523 168.168V139.7H33.4126V168.168H32.523Z",
    fill: "black"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4126 144.593C27.8427 144.593 25.4059 147.631 25.4059 151.971C25.4059 156.31 25.4059 162.386 33.4126 162.386",
    stroke: "black",
    strokeWidth: 0.868241
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M71.0204 155.014L59.9441 82.6958C59.743 81.3827 60.7591 80.1991 62.0875 80.1991H143.004C144.075 80.1991 144.985 80.9807 145.147 82.0392L156.324 155.014L198.339 164.26V173.44C198.339 174.638 197.368 175.609 196.171 175.609H108.367L72.5584 164.728C71.6449 164.45 71.0204 163.608 71.0204 162.653V155.014Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M108.351 172.356H140.335L173.945 167.477L184.245 164.225L151.719 153.383H73.6563V160.43L108.351 172.356Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M63.4122 87.2146L73.2315 149.014C73.4825 150.593 74.8445 151.756 76.4438 151.756H149.018C151.009 151.756 152.533 149.983 152.233 148.014L142.823 86.2145C142.581 84.6256 141.215 83.4516 139.607 83.4516H66.6245C64.6246 83.4516 63.0984 85.2394 63.4122 87.2146Z",
    fill: "#009CDB"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M82.0647 107.038L112.803 120.327L131.05 102.17L139.042 131.972L90.0567 136.84L82.0647 107.038Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M130.615 102.214L83.1436 106.931L112.48 119.269L130.615 102.214Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.8567 107.538L82.2727 106.537L112.631 119.151L130.295 102.36L131.042 103.146L112.867 120.423L81.8567 107.538Z",
    fill: "black"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 176.595,
    y: 101.772,
    width: 20.8378,
    height: 9.55065,
    rx: 4.77532,
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M180.936 101.772H189.618C189.618 104.17 187.675 106.113 185.277 106.113C182.88 106.113 180.936 104.17 180.936 101.772Z",
    fill: "#FFD5E5"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 190.487,
    cy: 98.2992,
    r: 1.73648,
    fill: "black"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 180.936,
    cy: 98.2992,
    r: 1.73648,
    fill: "black"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M176.646 116.123C171.039 106.105 163.914 100.679 158.203 103.715",
    stroke: "#FFA90D",
    strokeWidth: 8.68241,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerificationEmail);
export default __webpack_public_path__ + "static/media/verification-email.414b2a80dfd0cbef6ee93faedc58b49a.svg";
export { ForwardRef as ReactComponent };